import React from "react";
import PropTypes from 'prop-types';

import style from "./Team.css";
import LinkBar from "../LinkBar";
import Button from "../Button";
import MemberCard from "./MemberCard";

class Team extends React.Component {
  constructor (props) {
    super(props);
    this.state = {
      selectedIdx: 0
    };
  }

  handleSelect (selectedIdx) {
    this.setState({ selectedIdx });
  }

  render () {
    const teams = this.props.teams;
    const links = teams.map((team) => team.name);
    const team = teams[this.state.selectedIdx];
    const members = team.members.slice(0, 3);
    const url = `/openings?department=${team.id}`;
    const linkLabel = `View positions in ${team.name}`;
    let linkBar;

    if (links.length > 1) {
      linkBar = (
        <LinkBar
          links={links}
          selected={this.state.selectedIdx}
          activeStyle={{ color: "#ff5c39" }}
          onClick={(idx) =>
            this.handleSelect(idx)
          } />
      );
    }

    return (
      <div className={style.team}>
        <div className={style.content}>
          <div className={style.centerRow}>
            <h3 className={style.title} style={this.props.headerStyle}>
              Meet your
              <br />
              <span style={{
                display: "inline-block",
                width: "50px"
              }} />
              future teammates
            </h3>
            {linkBar}
          </div>

          <div className={style.row}>
            {members.map((member, idx) =>
              <MemberCard
                key={idx}
                member={member} />
            )}
          </div>

          <div className={style.centerRow}>
            <Button
              to={url}
              label={linkLabel} />
          </div>
        </div>
      </div>
    );
  }
}

Team.propTypes = {
  teams: PropTypes.array.isRequired,
  headerStyle: PropTypes.object
};

export default Team;



// WEBPACK FOOTER //
// ./component/Team/index.js